type BannerTag = "homeBanner" | "redemptionBanner";

export function getBannersQuery({ bannerTag }: { bannerTag: BannerTag }) {
    return `{
  bannerCollection(limit: 1, where: {
    contentfulMetadata:{
      tags:{
        id_contains_some: "${bannerTag}"
      }
    }
  }){
    items{
      itemsCollection{
        items{
          image{
            description
            url
          }
          linkTo
        }
      }
    }
  }
}`;
}
